import React, { useEffect } from "react";
import styles from "./accessDenied.module.scss";
import FordLogo from "../../common/FordLogo";
import { withTranslation } from "react-i18next";
import { invalidateSession } from "../../common/InvalidateSession";

const AccessDeniedNotOnboardedNsc = (props) => {
  useEffect(() => {
    props.history.push("/denied-nsc");
    invalidateSession();
  }, []);

  return (
    <div className="pageWrapper">
      <div className="pagePadding">
        <div className={styles.center}>
          <FordLogo className={styles.brandLogo} />
        </div>
        <div className={styles.deniedTitle}>
          {props.t("AccessDeniedNotOnboardedNsc.header")}
        </div>
        <div className={styles.subtext}>
          <div className={styles.awaitingManagement}>
            {props.t("AccessDeniedNotOnboardedNsc.subheader")}
          </div>
          <div className={styles.inOrderToAccess}>
            {props.t("AccessDeniedNotOnboardedNsc.sublineOne")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation("emp")(AccessDeniedNotOnboardedNsc);
